import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    menuTile: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  menuTile: string;
}




const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})